var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("navbar", {
    attrs: { onLanding: _vm.onLanding, verifiedAccount: _vm.verifiedAccount },
    scopedSlots: _vm._u([
      {
        key: "nav-items",
        fn: function () {
          return [
            _vm.show_account_select
              ? _c(
                  "li",
                  { staticClass: "nav-item" },
                  [
                    _c("dropdown", {
                      attrs: {
                        isNavbarDropdown: true,
                        entries: _vm.accessible_accounts,
                        formatText: (x) => x["company_name"],
                        formatValue: (x) => x["account_id"],
                        selected: _vm.requested_account,
                      },
                      on: { "update:selected": _vm.onRequestedAccountChange },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            !_vm.onLanding && _vm.verifiedAccount
              ? _c("li", { staticClass: "nav-item" }, [
                  _c(
                    "a",
                    { staticClass: "nav-link", attrs: { href: "/home" } },
                    [
                      _c("i", {
                        staticClass: "fa fa-home",
                        attrs: { "aria-hidden": "true" },
                      }),
                      _vm._v("\n        Dashboard\n        "),
                      _c("span", { staticClass: "sr-only" }, [
                        _vm._v("(current)"),
                      ]),
                    ]
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.isSuperAdmin
              ? _c("li", { staticClass: "nav-item" }, [
                  _c(
                    "a",
                    {
                      staticClass: "nav-link",
                      attrs: { href: "/admin_static/home" },
                    },
                    [
                      _c("font-awesome-icon", {
                        attrs: { icon: ["fas", "hammer"] },
                      }),
                      _vm._v("\n        Admin\n      "),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            !_vm.onLanding && _vm.verifiedAccount
              ? _c("li", { staticClass: "nav-item" }, [
                  _c(
                    "a",
                    { staticClass: "nav-link", attrs: { href: "/account" } },
                    [
                      _c("i", {
                        staticClass: "fa fa-user",
                        attrs: { "aria-hidden": "true" },
                      }),
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.accountSettingLabel) +
                          "\n      "
                      ),
                    ]
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("li", { staticClass: "nav-item" }, [
              _c(
                "a",
                {
                  staticClass: "nav-link",
                  attrs: { href: "#" },
                  on: { click: _vm.logout },
                },
                [
                  _c("i", {
                    staticClass: "fa fa-sign-out-alt",
                    attrs: { "aria-hidden": "true" },
                  }),
                  _vm._v("\n        Logout\n      "),
                ]
              ),
            ]),
            _vm._v(" "),
            !_vm.onLanding && _vm.verifiedAccount
              ? _c("li", { staticClass: "nav-item" }, [
                  _c(
                    "a",
                    {
                      staticClass: "nav-link btn btn-topbar ml-2",
                      attrs: { href: "/create" },
                    },
                    [
                      _c("i", {
                        staticClass: "fa fa-plus",
                        attrs: { "aria-hidden": "true" },
                      }),
                      _vm._v("\n        Create New Scan\n      "),
                    ]
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.isSubscribed
              ? _c("li", { staticClass: "nav-item" }, [
                  _c(
                    "a",
                    {
                      staticClass: "nav-link btn btn-topbar ml-2",
                      attrs: { href: "/generate-risk-report" },
                    },
                    [
                      _c("i", {
                        staticClass: "fa fa-plus",
                        attrs: { "aria-hidden": "true" },
                      }),
                      _vm._v("\n        Generate Risk Report\n      "),
                    ]
                  ),
                ])
              : _vm._e(),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }